import React from 'react'

import Container from '@mui/material/Container'

import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'
import Breadcrumbs from 'components/shared/Breadcrumbs'

import Form from 'components/account/Campers/Form'

const NewCamper = props => {
  const { queryLoading, mutationLoading, form } = props

  const buttonText = mutationLoading ? 'Creating...' : 'Create'

  return (
    <Container maxWidth='md'>
      <Breadcrumbs crumbs={[['Account Overview', '/'], ['Campers'], ['New']]} />
      <Typography pb={4} variant='h2' align='center'>
        Add a Camper
      </Typography>
      {!form || queryLoading ? (
        <Loading />
      ) : (
        <Form buttonText={buttonText} {...props} />
      )}
    </Container>
  )
}

export default NewCamper
